<template>
    <main>
        <div style="position:relative;z-index: 20;">
            <div v-click-outside="closelistsearchcompany" class="inputsearch  J-search-auto-list scrollmenucompany" v-if="listsearchopened" >
                <v-list v-if="arrayfindedcompanies.length <=0" style="background: white;">
                    <label style="margin-left:20px">No se encontró resultados</label>
                </v-list>
                <v-list v-else style="background: white;">
                    <div class="J-search-auto" v-for="arrayfindedcompanies in arrayfindedcompanies" :key="arrayfindedcompanies.length" @click="goprofilecompany(arrayfindedcompanies)"  style="cursor:pointer;padding-bottom:10px;">
                        <div class="J-search-auto-container">
                            <v-list-tile-avatar class="J-search-auto-avatar">
                                <img :src="arrayfindedcompanies.image_company.length<= 0 ? 'https://cdn.vuetifyjs.com/images/cards/foster.jpg' : arrayfindedcompanies.image_company[0].link">
                            </v-list-tile-avatar>
                            <div class="J-search-auto-content">
                                <div style="font-size: 15px; font-weight: bold">
                                    {{arrayfindedcompanies.name.toUpperCase()}}
                                </div>
                                
                            </div>
                            
                        </div>
                        <div class="J-letter-search-container">
                            <div v-for="(service,index) in arrayfindedcompanies.services" :key="index+1" >
                                <div  class="J-letter-search-item" :title="service.name" v-if="index<7">
                                    {{service.name.length>=15?service.name.substr(0,15):service.name}}
                                </div>
                            </div>
                        </div>
                    </div>

                </v-list>
            </div>
            <div class="JDropdown J-nav" ref="JDropdowns">
                <!-- head -->
                    <div  class="J-dropdown-header" v-if="false">
                        <h2 class="titNot a-dropdown-item"> Notificaciones:</h2>
                        <button class="J-btn-close a-dropdown-item" @click="closeNotify()">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <!-- Cuerpo -->
                    <div class="bodyNot a-dropdown-item">
                        <div v-for="notification in notificationslist" :key="notification.length" role="alert"  class="a-dropdown-item notification-item" :class="{'view-not':!notification.view}" @click="routeDirectionnotification(notification)">
                            <div class="a-dropdown-item  notification-item-avatar">
                                <div class="imagNotCont" >
                                    <img  :src="notification.photo" class="a-dropdown-item" alt="foto">
                                </div>
                            </div>
                            <div class="a-dropdown-item notification-item-text">
                                <p class="">{{notification.description}}</p>
                                <span class="notification-item-time">
                                    {{moment(notification.created_at).fromNow()}}
                                </span>
                                <!--p class="a-dropdown-item" style="color:rgb(180,180,180);font-size:13px;" >Hace 10 minutos</p -->
                            </div>
                        </div>
                    </div>
                    <!-- footer -->
                    <div style="background: rgb(240,240,240);text-align: center;">
                        <h5 class="footNot  a-dropdown-item"> -- Goot Work -- </h5>
                    </div>
            </div>
            <div class="JDropdown JDropdown-message" ref="JDropdownMessage">
                    <div class="bodyNot a-dropdown-item">
                        <component-conversation v-if="tabs[0].active&user_conversation!=null" :data_conversation="user_conversation" :is_company="false" @back="isTabActive"/>
                        <div v-if="tabs[1].active" class="">
                            <component-new-message :data="datamessage" :office="user" @back="closeDropdownMessage()" @select="selectUser"/>
                        </div>
                    </div>
            </div> 
            <v-toolbar 
                class="J-color-primary"
                dark
                fixed
                scroll-off-screen
                scroll-target="#scrolling-techniques"
                >
                <v-toolbar-title class="hidden-sm-and-down">
                    <img class="J-logo-g" src="/img/logo/favor.png"> 
                </v-toolbar-title>
                
                <v-spacer></v-spacer>

                <div class="J-search-option-content">
                    <div class="text-xs-center">
                        <input v-if="false" @click="openDropdown()" v-model="textsearch" @keyup="openlistsearch" class="J-form-input JDrop-input"  placeholder="¿Qué negocios deseas buscar?">
                        <div class="J-search-option-container JDrop" ref="JDrop">
                            <a v-show="false" href="javascript:void(0)" class="JDrop J-search-option-item" v-for="(search,index) in dataSearch" :key="index+1" @click="searchCategory(search.value)">
                                <div class="JDrop J-search-option-item-icon">
                                    <img class="JDrop J-search-option-item-img" :src="search.icon" alt="">
                                </div>
                                <div class="JDrop J-search-option-title">
                                    {{search.name}}
                                </div>
                            </a>
                        </div>  
                    </div>
                                         
                </div>
                <v-spacer></v-spacer>
                
                
                <button class="J-nav-menu-btn" @click="isOpenMenu()">
                    <i class="fas fa-bars" v-if="!openMenu"></i>
                    <i class="fas fa-times" v-else></i>
                </button>
                <div class="J-nav-menu" :class="{'show':openMenu}"  style="z-index:1000">
                    <v-menu offset-y style="z-index:1000!important">
                        <template  icon slot="activator">
                            <a href="javascript:void(0)" class="J-header-item">
                                Crear
                            </a>
                        </template>
                        <v-list>
                            <v-list-tile v-if="false">
                                <v-list-tile-content>
                                    <v-list-tile-title @click="goBussness()" class="fas fa-store" style="cursor:pointer">Negocio</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title @click="goHelp()"  class="fas fa-hands-helping" style="cursor:pointer">Ayuda</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="false">
                                <v-list-tile-content>
                                    <v-list-tile-title @click="goReferrals()"  class="fas fa-users" style="cursor:pointer">Referidos</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <!-- <v-list-tile>
                                <v-list-item>
                                    <v-list-item-title  class="fas fa-medkit" style="cursor:pointer">Crear sintomas</v-list-item-title>
                                </v-list-item>
                            </v-list-tile> -->
                        </v-list>
                    </v-menu>
                    <v-menu>
                        <v-btn icon  @click="goindex" data-toggle="tooltip" title="Inicio" slot="activator">
                            <v-icon>fas fa-home</v-icon>
                        </v-btn>
                    </v-menu>
                    <v-menu v-if="false"  :close-on-content-click="false" data-toggle="tooltip" title="Mensages" style="position:relative;z-index:1001">
                        <v-btn icon slot="activator" class="JBtn-dropdown" @click="goMessage">
                            <v-icon class="JBtn-dropdown-items">fas fa-comment</v-icon>
                        </v-btn>
                    </v-menu>
                    <v-btn v-if="false" icon  data-toggle="tooltip" class="JBtn-dropdown" title="Notificación" @click="mostrarOcultar(userstorage.notification,$event)">
                            <v-icon class="JBtn-dropdown">fas fa-bell</v-icon>
                            <span v-if="userstorage.notification>0"  class="campana JBtn-dropdown">{{userstorage.notification}}</span>
                    </v-btn>
                    <a v-if="!session" href="javascript:void(0)" class="J-header-item" @click="goLogin">Iniciar Sesión</a>
                    <v-menu v-if="false"  :close-on-content-click="false" style="position:relative;z-index:1001">
                        <v-btn icon slot="activator" data-toggle="tooltip" title="Orden" @click="goorder()">
                            <v-icon>fas fa-shopping-bag</v-icon>
                        </v-btn>
                    </v-menu>
                    <v-menu v-if="false"  :close-on-content-click="false" data-toggle="tooltip" title="Servicios agregados" style="position:relative;z-index:1001">
                        <v-btn icon slot="activator" @click="gocart()">
                            <v-icon>fas fa-shopping-cart</v-icon>
                        </v-btn>
                    </v-menu>
                    
                    <v-menu v-if="session"   :close-on-content-click="false" style="position:relative;z-index:1001">
                        <v-btn icon slot="activator" data-toggle="tooltip" title="Mis datos">
                            <v-icon>fas fa-user</v-icon>
                        </v-btn>
                        <v-list style="width:200px;">
                            <v-layout style="padding-bottom:20px;margin-left:10px">
                                <v-flex>
                                    <v-list-tile-avatar>
                                        <img :src="userstorage.photo">
                                        
                                    </v-list-tile-avatar>
                                </v-flex>
                                <v-flex>
                                    <v-list-tile-title style="margin-top: 5px; font-size: 20px; font-weight: bold">{{userstorage.username}}</v-list-tile-title>
                                </v-flex>
                            </v-layout>
                            <div class="row">
                                <div class="col-12">
                                    <div class="list-group" id="list-tab" role="tablist">
                                        <a @click="seeperfil" class="fas fa-address-card list-group-item list-group-item-action" id="list-home-list" data-toggle="list"  role="tab" aria-controls="home"> Perfil</a>
                                        <a @click="gofavorites" class="fas fa-star list-group-item list-group-item-action" id="list-profile-list" data-toggle="list" role="tab" aria-controls="profile" v-if="false"> Favoritos</a>
                                        <a @click="goReferrals" class="fas fa-users list-group-item list-group-item-action" id="list-profile-list" data-toggle="list" role="tab" aria-controls="profile" v-if="false">Crear referidos</a>
                                        <a  v-if="false" @click="dialogregistercompanyopen" class="fas fa-tshirt list-group-item list-group-item-action" id="list-messages-list" data-toggle="list" role="tab" aria-controls="messages"> Mis negocios</a>
                                        <a @click="logout" class="fas fa-sign-out-alt list-group-item list-group-item-action" id="list-settings-list" data-toggle="list" role="tab" aria-controls="settings"> Cerrar Sesión</a>
                                    </div>
                                </div>
                                
                            </div>
                        </v-list>
                    </v-menu>

                </div>

            </v-toolbar>
            <v-layout>
                <v-dialog v-model="dialog" style="z-index:1000"   width="500"> 
                    <div style="overflow: scroll; background: white">
                        <component-local-target v-if="contentlaundry"/>
                        <component-taxis-target v-if="contenttaxis"/>
                    </div>
                    <div>
                        <v-btn color="primary" style="width:95%" @click="closemodal">Cancelar</v-btn>
                    </div>
                </v-dialog>
                <div>

                </div>
            </v-layout> 
        </div>
        <companyregister/>
        <modal-component/>
        <userprofile v-if="session"/>
        <component-modalvenues/>
        <component-forget-password/>

    </main>
</template>
<script>

import forgetpasswordcomponent from '@/components/Templates/Views/forgetpassword'

// Import the EventBus we just created.
import ClickOutside from 'vue-click-outside'

import conversation from '@/components/Templates/modulos/Chat/conversation'
import new_message from '@/components/Templates/modulos/Chat/new_message_user'
import companyregister from '@/components/Templates/Views/companyregister'
import modal from '@/components/Templates/Views/modal'
import modalCreationVenues from '@/components/Templates/Views/modalCreationVenues'
import modalvenues from '@/components/Templates/Views/modalvenues'
import userprofile from '@/components/Templates/Views/userprofile'
import { EventBus } from '@/helpers/eventbus/event-bus'
import { IdentStorage, LocationStorage, SearchListStorage, UsersStorage, } from '@/helpers/storage.js'
import { NotificationsService } from "@/services"
import initVue from '../../../helpers/initVue'
import localTarget from './target-local.vue'
import taxiTarget from './target-taxis.vue'
const moment = require('moment')
const alertify = require('alertifyjs')

import {
    mapGetters
} from 'vuex'

export default {
    
    directives: {
        ClickOutside
    },
    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),
    data(){
        return{
            searchListStorage:new SearchListStorage(),
            openMenu:false,
            identity: null,
            session: false,
            token: null,
            dialog: false,
            user_conversation:null,
            user:null,
            datamessage:[],
            contentlaundry: false,
            contenttaxis: false,
            userstorage: {},
            nameicon: '',
            textsearch : '',
            moment:moment,
            dataSearch:[
                {
                    name:"Restaurantes",
                    value:"restaurante",
                    icon:"/img/markers/restaurante.svg",
                },
                {
                    name:"Bodegas",
                    value:"bodega",
                    icon:"/img/markers/bodegas.svg",
                },
                {
                    name:"Lavanderias",
                    value:"lavanderia",
                    icon:"/img/markers/lavanderias.svg",
                },
            ],
            tabs:[
                {title:'message',active:false},
                {title:'conversation',active:true},
                {title:'detail',active:false},
            ],
            listsearchopened: false,
            arrayfindedcompanies: [],
            wordstosearchcompanies: '',
            n: 3,
            notificationslist: [],
            datanovisible: 0,
            locationStorage:new LocationStorage(),
            usersStorage:new UsersStorage(),
            identStorage:new IdentStorage(),

        }
    },

    components:{
        'component-new-message':new_message,    
        'component-conversation':conversation,    
         'component-forget-password':forgetpasswordcomponent,
        'component-local-target':localTarget,
        'component-taxis-target': taxiTarget,companyregister,
        userprofile, 
        'modal-component':modal, 
         'modalCreationVenues':modalCreationVenues,'component-modalvenues':modalvenues
    },
    sockets:{
        
        "notifications:rabbit"(data){
            this.notificacionBasica(null,`quiere ayudarte`,``,'')
        },
        'location:user-helping'(data){
            if(data!=null){
                this.notificacionBasica(null,`${data.user.name.toUpperCase()} quiere ayudarte`,`conversation-user?type=user&datauser=${data.user._id}&color=11679a`)
            }
        },
        'symptoms-alert'(data){
            if(data!=null){
                this.notificacionBasica(null,`${data.user.message}`,'',`${data.user.name}`);
            }
        },
        message_new(data){
            var message={
                id_user:data.message.id_user,
                name:data.message.name,
                message:data.message.message,
                avatar:data.message.avatar,
            };
            this.notificacionBasica(message,'','message')
        },
        'help-alert'(data){
            if(data!=null){
                data.color=data.user.priority=='alta'?'fa5252':"ffc107";
                data.location_user=this.locationStorage.get()||null;
                this.notificacionBasica(data,'','helping-user')
            }
        },
        new_notifications(data){
            this.addNotification(data)
        },
    },
    created(){
        //localStorage.removeItem('user')
            var checked=localStorage.getItem('datanovisible');
            //console.log(checked)
            if(checked!=null){
                this.datanovisible = parseInt(checked)      
            }else{
                this.datanovisible = 0
            }
    },
    async mounted() {
        var me=this;
        
        this.getidentity()
        //console.log(this.identity)
        
        //console.log('dick');
        await this.getuser()
        EventBus.$on('getuser', () =>{
            this.getuser()
        })
        this.getnotifications()

        

    },
    methods: {
        closeNotify(){
            console.log("hey")
            var JDropdowns=this.$refs.JDropdowns;
            JDropdowns.classList.toggle("show")
        },
        closeDropdownMessage:function(){
            var jdropdownsMessage=this.$refs.JDropdownMessage;
            jdropdownsMessage.classList.toggle("show")
                    
        },
        isTabActive:function(index){
            //console.log(index);
            
            this.tabs.forEach(element=>{
                element.active=false;
            });
            this.tabs[index].active=true;
        },
        getNewMessage:function(idroom){
            if(idroom==undefined) return;
            axios.get(`user/new-message/${idroom}`)
            .then(res=>{
                const {data}=res.data;
                if(data != null){
                    this.datamessage=data.chats;
                    if(this.datamessage != null){
                        
                    }else{

                    }
                }
            })
        
        },
        isOpenMenu(){
            this.openMenu=!this.openMenu;
        },
        addNotification(data){
            this.notificationslist.unshift(data)
            this.notificationslist = this.notificationslist.slice(0, 20)
            this.userstorage.notification++;
            
            localStorage.setItem('user',JSON.stringify(this.userstorage))
            this.notificacionBasica(null,`${data.description}`,``,'')
            
        },
        searchCategory:function(name){
            this.closeDropdown();
            this.textsearch=name;

            var url=window.location.pathname
            if(url!='/'&&url!=''){
                this.openlistsearch();
            }
            else{
                EventBus.$emit('search-maps',name)   
            }

            
        },
        openDropdown:function(){


            var jdrop=this.$refs.JDrop;
            jdrop.classList.toggle("show")
        },
        closeDropdown:function(){
            var jdrop=this.$refs.JDrop;
            jdrop.classList.remove('show')
        },
        goBussness(){
           EventBus.$emit('companyregister')
        },
        selectUser:function(data){
            console.log('this.user_conversation')

            this.user_conversation={
                id:data._id,
                name:data.fullname||data.name,
                avatar:data.photo||[data.image_company],
                session:null
            };
            console.log(this.user_conversation)
            this.isTabActive(0)
        },
        goMessage(e){
            var data=this.usersStorage.get();
            var iden=this.identStorage.get()
            this.user={
                id:iden._id,
                name:data.fullname,
                photo:data.photo
            }
                var position=e.target;

            this.getNewMessage(iden._id)
            var jdropdown=this.$refs.JDropdownMessage;
            var style=jdropdown.style;

            this.hiddenDropdown()

            if(e.target.parentNode.className.includes('JBtn-dropdown')){
                position=e.target.parentNode
            }
            else if(e.target.parentNode.parentNode.className.includes('JBtn-dropdown')){
                position=e.target.parentNode.parentNode
            }
            
            var rectPosition=position.getBoundingClientRect()
            style.top=(rectPosition.top+rectPosition.height+10)+'px';
            

             var result=e.clientX-jdropdown.clientWidth+30;
            if(result<0) style.left=0+'px';              
            else style.left=result+'px';
            jdropdown.classList.toggle("show")
        },
        goHelp(){
            EventBus.$emit('alert','search-help')
        },
        goReferrals(){
            EventBus.$emit("goModalReferrals")
        },
        closemodal(){
            var box = document.getElementById('JDropdown');
            box.style.display="none"
        },
        async subscription(){
            const PUBLIC_VAPID_KEY='BNuDwkzT0CB_Nwze9rQmxPclMYG83g7-6SMLTsyqOb5hx-tAC2laArB6GyvsZ1WzeyOYwhahNSGgB8cQbhfLq6s'
            const register=await navigator.serviceWorker.register('/worker.js',{
                scope:'/'
            })
            console.log('worker!')
            const subscription =await register.pushManager.subscribe({
                userVisibleOnly:true,
                applicationServerKey:this.urlBase64ToUint8Array(PUBLIC_VAPID_KEY),
            });
            //service worker
            await this.axios.post('/subscription',{
                subscription
            })
            console.log('subscribed!')
        },
        urlBase64ToUint8Array(base64String){
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        
            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);
        
            for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        },
        mostrarOcultar(data,e){
            this.hiddenDropdown()
            this.subscription()
            // if(!this.Push.Permission.has()){
            //     this.Push.Permission.request(()=>{console.log("granted")}, ()=>{console.log("denied")});
            // }

            if(data>0){
                this.$socket.emit('notification:view-alert')
                this.userstorage.notification=0;
                localStorage.setItem('user',JSON.stringify(this.userstorage))
            }

            var jdropdown=this.$refs.JDropdowns;
            var position=e.target;
            var style=jdropdown.style;

            
            if(e.target.parentNode.className.includes('JBtn-dropdown')){
                position=e.target.parentNode
            }
            else if(e.target.parentNode.parentNode.className.includes('JBtn-dropdown')){
                position=e.target.parentNode.parentNode
            }
            // if(e.target.parentNode.classList){

            // }
            // var top=(e.clientY+position.clientHeight)
            var rectPosition=position.getBoundingClientRect()
            style.top=(rectPosition.top+rectPosition.height+10)+'px';
        
            var result=e.clientX-jdropdown.clientWidth+30;
            if(result<0) style.left=0+'px';              
            else style.left=result+'px';
            jdropdown.classList.toggle("show")

        },     
        makeelementvisible(){
            this.datanovisible = 0
            localStorage.removeItem('datanovisible')
        },
        remove (item) {
            const index = this.friends.indexOf(item.name)
            if (index >= 0) this.friends.splice(index, 1)
        },
        routeDirectionnotification:function(item){
            this.hiddenDropdown()
            var route=''
            if(item.name == 'user aggregate'){
               route = `/empresa/created/${item._id}`
            }
            else if(item.name == 'new order'){
                
               route = `/empresa/created/${item._id_company}?office=${item._id_office}&order=${item.data.order._id_order}`
            }
            else{
               route = `/orders`
            }

            this.sendViewNotification(item)
            this.$router.push(route);
        },
        sendViewNotification(data){
            this.$socket.emit("notification:view",data)
        },
        gocart:function(){
            this.$router.push('/cart');
        },
        goorder:function(){
            this.$router.push('/orders');
        },
        goprofilecompany(paramsarraycompany){
            this.listsearchopened = false
            this.searchListStorage.set(paramsarraycompany.services);
            window.location = `/services/${paramsarraycompany._id}`
        },

        getuser(){
            var checked=localStorage.getItem('user');
            if(checked!=null){
                this.userstorage = JSON.parse(checked);
                return;             
            }
            if(this.session){
                this.axios.get(`users/getuser`)
                .then((res) => {
                    localStorage.setItem('user',JSON.stringify(res.data.user))
                    this.userstorage = res.data.user
                })
            }
            
        },
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            
        },
        getnotifications(){
            if(this.session){
                var query={}
                NotificationsService.list(query)
                .then(response=>{
                    this.notificationslist = response.data.notifications
                    //console.log(response)
                    //console.log(this.notificationslist)
                    
                })
            }
            
        },
        closelistsearchcompany(){
            this.listsearchopened = false
        },

        logout(){
            if(window.navigator && navigator.serviceWorker) {
                navigator.serviceWorker.getRegistrations()
                .then(function(registrations) {
                    for(let registration of registrations) {
                        registration.unregister();
                    }
                });
            }
            this.axios.get('user/logout/'+this.identity._id)
            this.userstorage = {}
            this.identity = null
            this.token = null
            localStorage.removeItem('iden')
            localStorage.removeItem('user')
            localStorage.removeItem('tok')
            localStorage.clear()
            this.$store.dispatch('saveIdentity', null)
            this.$store.dispatch('saveToken', null)
            window.location = '/'

        },

        goLogin(){
            EventBus.$emit('goLogin')
        },
        
        seeperfil(){
            EventBus.$emit('opendialog')
        },

        openshowloundry(){
            this.dialog = true
            this.contentlaundry = true
            this.contenttaxis = false
        },

        openshowtaxis(){
            this.dialog = true
            this.contenttaxis = true
            this.contentlaundry = false
        },

        goindex(){
            this.$router.push('/');
        },

        closemodal(){
            this.dialog = false
        },

        dialogregistercompanyopen(){
            EventBus.$emit('companyregister')  
        },

        gofavorites(){
            EventBus.$emit('openmodalfavoritescompany')
        },
        
        openlistsearch(){
            let textempty = this.textsearch === ''
            if(textempty){
                this.listsearchopened = false
            }else{
                this.closeDropdown()
                if(this.textsearch.length<4) return;
                this.axios.get(`company/findcompany/${this.textsearch}`)
                /******************* * Login Exitoso!!!!******************************* */
                .then(res => {
                  console.log(res.data.company)
                  this.arrayfindedcompanies = res.data.company
                  this.listsearchopened = true
                  //console.log(this.arrayfindedcompanies)
                
                })
                /******************* * Login Errado!!!!********************************/
                .catch(() => {
                  this.listsearchopened = false
                })
            }
        }
    },
    watch: {
        tokenU:function(e){
            this.getidentity()
        }
    }
}
</script>